// Estilos exclusivos do FormularioTab (Rede, Tipos de Entrega, Parceiro,
// Velocidade, Cliente Final, POP e Regional, Equipamentos, Meio de Entrega) —
// extraídos de circuito/styles.js na Task 6 da decomposição.
const styles = (theme) => ({
	boxRow: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
		alignItems: "center",
	},
	colapse: { width: "100%" },
	boxFieldWithConfig: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		position: "relative",
	},
	paperModalEditCheckBoxLabel: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		p: 1,
		borderRadius: 2,
		maxHeight: "30vh",
		position: "relative",
		pt: 0,
	},
	paperModalEditCheckBoxStickHeader: {
		display: "flex",
		flexDirection: "column",
		position: "sticky",
		backgroundColor: theme.palette.background.paper,
		top: 0,
		zIndex: 99999,
		gap: 1,
		pt: 2,
		mt: -2,
	},
	editCheckBoxTexts: {
		display: "flex",
		alignItems: "center",
		maxWidth: "250px",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	textField: {
		fontSize: "0.96rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "6px 8px", // padding interno reduzido
			fontSize: "0.96rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.96rem", // fonte da label
		},
	},
	formControlItems: {
		"&.MuiGrid-item": {
			pt: 0,
			height: "34px",
			display: "flex",
			alignItems: "center",
		},
	},
	gritItemTitle: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		flexDirection: "row",
		width: "100%",
	},
	titleWithConfig: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
		alignItems: "center",
	},
	contentIdentation: {
		pl: 5,
		pt: 2,
	},
	linearProgress: {
		position: "absolute",
		top: 8,
		left: 8,
		right: 0,
		zIndex: 1,
		borderTopLeftRadius: 4,
		borderTopRightRadius: 4,
	},
	noDeliveryFound: { verticalAlign: "middle", fontSize: 20 },
	limitWidthCheckbox: {
		display: "inline-block",
		maxWidth: 140, // ajuste conforme necessário
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		verticalAlign: "middle",
	},
});

export default styles;
